// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SystemDocument } from '@interfaces/document.interfaces';
import { ModalSize } from '@interfaces/shared.interfaces';
import { OEM } from '@interfaces/user.interfaces';
import { DealershipService } from '@services/dealership.service';
import { SharedService } from '@services/shared.service';
import { UserService } from '@services/user.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeWhile } from 'rxjs';
import { SystemDocumentModalComponent } from 'src/app/modals/system-document-modal/system-document-modal.component';
import { tenantIsStellantis } from 'src/app/utils/utils';

@Component({
    selector: 'app-upload-dashboard',
    templateUrl: './upload-dashboard.component.html',
    styleUrls: ['./upload-dashboard.component.scss'],
})
export class UploadDashboardComponent implements OnInit, OnDestroy {
    private isComponentAlive = true;
    private systemDocs: SystemDocument[] = [];

    public year = new Date().getFullYear();
    public showImage = false;
    public companyImage: string = null;
    public productImage: string = null;

    constructor(
        private readonly userService: UserService,
        private readonly dialog: MatDialog,
        private readonly deviceService: DeviceDetectorService,
        private readonly dealershipService: DealershipService,
        private readonly sharedService: SharedService
    ) {}

    ngOnInit() {
        if (tenantIsStellantis()) {
            this.showImage = true;
        }

        this.setImages();
    }

    private oemChange(): void {
        this.dealershipService.dealershipUpdate$.pipe(takeWhile(() => this.isComponentAlive)).subscribe((dealer) => {
            if (dealer.oemCode === OEM.stellantis) {
                this.companyImage = '../../../assets/img/stellantis-logo-white.png';
                this.productImage = '../../../assets/img/ez-docs-logo-white.png';
            } else {
                this.companyImage = '../../../assets/img/DDJ-logo-white.png';
                this.productImage = '../../../assets/img/cropped-ud-logo-white.png';
            }
        });
    }

    private setImages(): void {
        if (tenantIsStellantis()) {
            this.companyImage = '../../../assets/img/stellantis-logo-white.png';
            this.productImage = '../../../assets/img/ez-docs-logo-white.png';
        } else {
            this.companyImage = '../../../assets/img/DDJ-logo-white.png';
            this.productImage = '../../../assets/img/cropped-ud-logo-white.png';
        }
    }

    private async getSystemDocuments(type: number): Promise<void> {
        //Load documents only when trying to view documents and only once.
        if (this.systemDocs.length === 0) {
            this.userService
                .getHelpPageSystemDocuments()
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((docs) => {
                    this.systemDocs = docs;
                    this.openModal(type);
                });
        } else {
            this.openModal(type);
        }
    }

    private openModal(docType: number): void {
        this.dialog.open(SystemDocumentModalComponent, {
            width: this.sharedService.getModalWidth(ModalSize.Medium) + 'px',
            height: this.sharedService.getModalHeight(ModalSize.Medium) + 'px',
            closeOnNavigation: false,
            data: {
                modalSize: ModalSize.Medium,
                doc: this.systemDocs[docType],
            },
        });
    }

    public viewDocument(type: number): void {
        this.getSystemDocuments(type);
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
